import { RootStateOrAny, useSelector } from 'react-redux'

import { NumberOfPortions } from 'routes/Menu/domains/basket'
import { getNumPortions } from 'selectors/basket'

export const useNumPortions = () => {
  const numPortions = useSelector<RootStateOrAny, NumberOfPortions>(getNumPortions)

  return { numPortions }
}
